
// 金额永不出现（spec 1 §5 / spec 2 §7）：卡片 DTO 本身零金额字段，组件也不渲染任何价格位
export default {
  name: 'AssistantOrderCard',
  props: {
    card: { type: Object, required: true },
    admin: { type: Boolean, default: false }
  },
  data () {
    return { copied: false } // 复制成功的瞬态反馈（1.6s 后回落图标）
  },
  beforeDestroy () {
    clearTimeout(this._copyTimer)
  },
  computed: {
    // 状态色归并到现有订单卡四档（与 Order.vue status-tag 同色系）：
    // 进行中（黄）/ 配送中（蓝）/ 已送达（橙）/ 已完成（绿）/ 已取消（橙红）
    statusClass () {
      const s = this.card.status || ''
      if (s === 'delivering') return 'delivering'
      if (s === 'delivered') return 'delivered'
      if (s === 'confirmed') return 'confirmed'
      if (s === 'cancelled') return 'cancelled'
      return 'pending' // pending_confirm/picked/inspected 等进行中态
    }
  },
  methods: {
    // 复制订单号：copy 事件已 stopPropagation（模板 @click.stop），不会触发整卡 open 跳转
    async copyNo () {
      const no = String(this.card.display_no || '')
      if (!no || this.copied) return
      let ok = false
      try {
        await navigator.clipboard.writeText(no)
        ok = true
      } catch (_) {
        // Clipboard API 不可用（旧内核/非安全上下文）→ execCommand 兜底；再失败 → 项目既有 alert 回退
        try {
          const ta = document.createElement('textarea')
          ta.value = no
          ta.setAttribute('readonly', '')
          ta.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0'
          document.body.appendChild(ta)
          ta.select()
          ok = document.execCommand('copy')
          document.body.removeChild(ta)
        } catch (_) { ok = false }
      }
      if (!ok) { alert('复制失败，请手动选择'); return }
      this.copied = true
      clearTimeout(this._copyTimer)
      this._copyTimer = setTimeout(() => { this.copied = false }, 1600)
    },
    // "2026-09-17 10:26:33" → "09-17 10:26"（聊天卡省年份；非字符串原样返回）
    fmtTime (v) {
      const s = String(v || '')
      return /^\d{4}-\d{2}-\d{2} /.test(s) ? s.slice(5, 16) : s
    }
  }
}
